import { DefaultOptionType } from "antd/es/select";

export const data: any[] = [
  {
    id: "1",
    title:
      "Horem ipsum dolor sit amet, consectetur adipiscing elit.  ipsum dolor sit amet, consectetur adipiscing elit?",
    category: "In Progress",
    createDate: "2023/06/12 15:40",
    status: "Show",
    description: "<p>12312321312123123312233</p>",
    hashTag: ["12313", "123123"],
  },
  {
    id: "2",
    title:
      "Horem ipsum dolor sit amet, consectetur adipiscing elit.  ipsum dolor sit amet, consectetur adipiscing elit?",
    category: "In Progress",
    createDate: "2023/06/12 15:40",
    status: "Hide",
    description: `<p>12312321312123123312233</p>`,
    hashTag: ["12313", "123123"],
  },
  {
    id: "3",
    title:
      "Horem ipsum dolor sit amet, consectetur adipiscing elit.  ipsum dolor sit amet, consectetur adipiscing elit?",
    category: "In Progress",
    createDate: "2023/06/12 15:40",
    status: "Hide",
    description: "<p>12312321312123123312233</p>",
    hashTag: ["12313", "123123"],
  },
  {
    id: "4",
    title:
      "Horem ipsum dolor sit amet, consectetur adipiscing elit.  ipsum dolor sit amet, consectetur adipiscing elit?",
    category: "In Progress",
    createDate: "2023/06/12 15:40",
    status: "Show",
    description: "<p>12312321312123123312233</p>",
    hashTag: ["12313", "123123"],
  },
  {
    id: "5",
    title:
      "Horem ipsum dolor sit amet, consectetur adipiscing elit.  ipsum dolor sit amet, consectetur adipiscing elit?",
    category: "In Progress",
    createDate: "2023/06/12 15:40",
    status: "Show",
    description: "<p>12312321312123123312233</p>",
    hashTag: ["12313", "123123"],
  },
  {
    id: "6",
    title:
      "Horem ipsum dolor sit amet, consectetur adipiscing elit.  ipsum dolor sit amet, consectetur adipiscing elit?",
    category: "In Progress",
    createDate: "2023/06/12 15:40",
    status: "Show",
    description: "<p>12312321312123123312233</p>",
    hashTag: ["12313", "123123"],
  },
  {
    id: "7",
    title:
      "Horem ipsum dolor sit amet, consectetur adipiscing elit.  ipsum dolor sit amet, consectetur adipiscing elit?",
    category: "In Progress",
    createDate: "2023/06/12 15:40",
    status: "Show",
    description: "<p>12312321312123123312233</p>",
    hashTag: ["12313", "123123"],
  },
  {
    id: "8",
    title:
      "Horem ipsum dolor sit amet, consectetur adipiscing elit.  ipsum dolor sit amet, consectetur adipiscing elit?",
    category: "In Progress",
    createDate: "2023/06/12 15:40",
    status: "Show",
    description: "<p>12312321312123123312233</p>",
    hashTag: ["12313", "123123"],
  },
];

export const statusOptions: DefaultOptionType[] | undefined = [
  {
    label: "공개",
    value: "SHOWING",
  },
  {
    label: "비공개",
    value: "HIDING",
  },
];

export const groupBuyingOptions: DefaultOptionType[] | undefined = [
  {
    label: "In Progress",
    value: "In Progress",
  },
  {
    label: "Finish",
    value: "Finish",
  },
];
